import { ContentState, EditorState } from 'draft-js';
import { convertFromHTML as draftConvertFromHtml } from 'draft-convert';

import convertFromText from './convertFromText';
import { Format, IEditorProps } from './types';

export default function(props: IEditorProps) {
  function convertText() {
    const contentState = ContentState.createFromText(props.text || '');
    const createdEditorState = EditorState.createWithContent(contentState);
    const convertedEditorState = convertFromText({
      editorState: createdEditorState,
      mentions: props.mentions,
    });

    return EditorState.moveFocusToEnd(convertedEditorState);
  }

  function convertHTML() {
    const blocksFromHTML = draftConvertFromHtml(props.text || '');
    const convertedEditorState = EditorState.createWithContent(blocksFromHTML);

    return EditorState.moveFocusToEnd(convertedEditorState);
  }

  return props.format === Format.text ? convertText() : convertHTML();
}
